<template>
    <div class="container mx-auto px-4 py-4">
        <div class="flex items-center justify-between">
          <div class="flex items-center">
            <a href="#" class="text-xl font-bold text-primary">
              <img src="@/assets/logo.png" alt="Logo" class="h-8 mr-2">
            </a>
          </div>
          
          <!-- Desktop Login Button -->
          <div class="hidden md:block">
            <a href="#" v-on:click="LogOut()" class="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors">
              Wyloguj się
            </a>
          </div>
          
          <!-- Mobile Menu Button -->
          <button class="md:hidden text-gray-700 focus:outline-none" @click="isMenuOpen = !isMenuOpen">
            <Menu v-if="!isMenuOpen" class="h-6 w-6" />
            <X v-else class="h-6 w-6" />
          </button>
        </div>
        
        <!-- Mobile Menu -->
        <div v-if="isMenuOpen" class="md:hidden mt-4 pb-2 flex justify-center">
          <a href="#" v-on:click="LogOut()" class="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors">
            Wyloguj się
          </a>
        </div>
      </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { Menu, X } from 'lucide-vue-next';
import { useUsersStore } from './../stores/users';

const isMenuOpen = ref(false);


const LogOut = async() =>{
  try {
      await useUsersStore().logout();
      navigateTo('/login');
      
    } catch (error) {
      console.error("Error during logout");
    }
    navigateTo('/login');
}

</script>